"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListArticle = ListArticle;
exports.callBackVirtual = callBackVirtual;
exports.getDetail = getDetail;
exports.getLogDetail = getLogDetail;
exports.getOrderDetail = getOrderDetail;
exports.getSettingInfo = getSettingInfo;
exports.getVirtualLog = getVirtualLog;
exports.getVirtualState = getVirtualState;
exports.sendOrder = sendOrder;
exports.settingOrder = settingOrder;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor 
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    brandId = _ref.brandId,
    cateId = _ref.cateId,
    orderNo = _ref.orderNo,
    outOrderNo = _ref.outOrderNo,
    page = _ref.page,
    related = _ref.related,
    status = _ref.status,
    supplierId = _ref.supplierId,
    _ref$dataRenage = _ref.dataRenage,
    dataRenage = _ref$dataRenage === void 0 ? [] : _ref$dataRenage;
  var _ref2 = dataRenage || [],
    _ref3 = _slicedToArray(_ref2, 2),
    startTime = _ref3[0],
    endTime = _ref3[1];
  var data = {
    brandId: brandId,
    cateId: cateId,
    orderNo: orderNo,
    outOrderNo: outOrderNo,
    page: page,
    related: related,
    status: status,
    supplierId: supplierId,
    endTime: endTime,
    startTime: startTime
  };
  return (0, _request.default)({
    url: '/admin/order/virtual/list',
    method: 'GET',
    params: data
  });
}

/**
 * 详情
 * @param orderNo
 * @constructor
 */
function getOrderDetail(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/virtual/detail/".concat(orderNo),
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 订单发货
 * @param {*} data 
 * @returns 
 */
function sendOrder(data) {
  return (0, _request.default)({
    url: "/admin/order/shipments",
    method: 'post',
    data: data
  });
}

/**
 * 维护订单
 * @returns 
 */
function settingOrder(data) {
  return (0, _request.default)({
    url: "/admin/order/virtual/status",
    method: 'post',
    data: data
  });
}

/**
 * 查询维护订单信息
 * @returns 
 */
function getSettingInfo(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/virtual/status/".concat(orderNo),
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 订单回调
 */
function callBackVirtual(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/virtual/get/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 查询订单
 */
function getVirtualState(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/virtual/get/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 订单日志
 */
function getVirtualLog(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/virtual/log/list/".concat(orderNo),
    method: 'get'
  });
}

/**
 * 拼团详情
 */
function getDetail(pinkId) {
  return (0, _request.default)({
    url: "/admin/store/pink/detail?pinkId=".concat(pinkId),
    method: 'get'
  });
}

/**
 * 拼团日志详情
 */
function getLogDetail(params) {
  return (0, _request.default)({
    url: "/admin/store/pink/logDetail",
    method: 'get',
    params: params
  });
}